import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "NaNoWriMo",
  "description": "",
  "published": "2006-10-29T00:00:00.000Z",
  "redirect_from": ["/blog/nanowrimo/swizec/375"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`S skorajsnim koncem oktobra se nam NaNoWriMo nevzdrzno priblizuje. To bo kaoticen mesec hitrega misljenja, se hitrejsega tipkanja in neizmernih kolicin kofeina.`}</p>
    <p>{`Cilj je, kot morda ze veste, napisati celoten roman v enem kratkem mesecu, ali pa vsaj prvih 50 tisoc besed le-tega, no, ni nujno, da ravno prvih; 50k besed v glavnem. Naloga se je lani izkazala za dosegljivo, saj sem v manj kot mesecu dosegel priblizno 55k besed. Roman ni bil potem nikoli dokoncan, se manj pa izdan. Letos bom skusal osebni cilj 90k besed doseci raje z serijo medsebojno povezanih novel, ki bodo verjetno izpadle kot nekaksna poglavja romana. Ko bo vsega konec pa bom storil se vse v svoji moci, da bi prislo do izdaje te zmesnjave besed.`}</p>
    <p>{`Kot ste lahko opazili ze v zadnji novici, novembra ne bo novih stripov. Ce zelim spisati 3000 besed na dan je dokaj ocitno, da ne ostane ravno veliko casa se za kaj drugega. Poskusil pa bom, pisati ta blog/novice vsak dan, tako da bi se ustvaril nekaksen popis NaNoWriMo dogajanja, ne vem se zakaj bo to dobro, ampak skodovati ne more.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      